import { RouterProvider, createRouter } from '@tanstack/react-router';
import { Helmet } from 'react-helmet-async';

import { AppProvider } from '@/providers/app';
import { routeTree } from '@/routeTree.gen';

const router = createRouter({
	routeTree,
});

declare module '@tanstack/react-router' {
	interface RegisterRouter {
		router: typeof router;
	}
}

export const App = () => {
	return (
		<AppProvider>
			<Helmet />
			<RouterProvider router={router} />
		</AppProvider>
	);
};
